
const NotificationsDrawer = () => {
    return (
        <div></div>
    )
};

export default NotificationsDrawer;